export interface EmployeeAge {
  years: number;
  months: number;
}

export const getEmployeeAge = (
  dateOfBirth: Date | null | undefined,
  today: Date = new Date()
): EmployeeAge | null => {
  if (!dateOfBirth) return null;

  let totalMonths =
    (today.getFullYear() - dateOfBirth.getFullYear()) * 12 +
    (today.getMonth() - dateOfBirth.getMonth());
  if (today.getDate() < dateOfBirth.getDate()) totalMonths--;
  if (totalMonths < 0) return null;

  return { years: Math.floor(totalMonths / 12), months: totalMonths % 12 };
};
